module.exports = "<div [hidden]=\"!active\"> <ng-content></ng-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/generic/tabs/tab/tab.component.html
// module id = 205
// module chunks = 0